export default {
  LOAD_MY_SURVEY_FORM_PAGE_START: 'LoadMySurveyFormPageStart',
  LOAD_MY_SURVEY_FORM_PAGE_END: 'LoadMySurveyFormPageEnd'
};